@if (usersData.content.length > 0 || search || isLoading) {
  <lgv-search-input placeholder="admin_users_search" (searchChanged)="onSearch($event)"></lgv-search-input>
}
@if (usersData.content.length > 0 && !isLoading) {
  <lgv-generic-table
    [tableDataSubject]="usersTableChanged"
    [page]="page"
    [pageSize]="count"
    [totalCount]="totalCount"
    (pageChanged)="onPageChanged($event)"
    (updateRowEvent)="editClicked($event)"
    (deleteRowEvent)="deleteClicked($event)"
    (sendInviteEvent)="sendInviteClicked($event)"
    (changeAccountStatusEvent)="changeAccountStatusClicked($event)"
  ></lgv-generic-table>
}

<lgv-fab-button type="add" (btnClicked)="addClicked()"></lgv-fab-button>

@if (usersData.content.length === 0 && !isLoading && search) {
  <lgv-empty-state
    symbol="help"
    titleText="admin_users_notfound_title"
    text="admin_users_notfound_message"
  ></lgv-empty-state>
}

@if (usersData.content.length === 0 && !isLoading && !search) {
  <lgv-empty-state
    symbol="add_circle"
    titleText="admin_users_init_title"
    text="admin_users_init_message"
  ></lgv-empty-state>
}
